<template>
  <section class="container-full-5">
    <h2 class="secondary-font gap-4 mt-2 mb-6">Membres - Liste des membres</h2>

    <div class="clear-both h-0"></div>
    
    <div v-if="loading && members.length === 0" class="flex-center py-10">
      <div class="loader dark"></div>
    </div>

    <div v-if="errorMessage" class="alert alert-danger mb-4">
      {{ errorMessage }}
    </div>

    <div class="s20">
      <!-- Import CSV Component -->
      <div class="mb-5">
        <import-membres-component 
          :key="refreshKey"
          @completed="onMembersImported"
        />
      </div>
      
      <div class="s20 widget pb-2">
        <div class="container-full-2 s20 my-5">
          <div class="s7">
            <h4 class="font-semibold mt-4">Utilisateurs <span class="text-sm text-grey-500">(recent)</span></h4>
          </div>
          <div class="s13 flex justify-content-right">
            <button type="button" @click="downloadCsv" class="btn normal ml-3 justify-content-center btn-filtre">
              <img src="/public/icons/icon-telecharger.svg" class="btn-icon" alt="" />
              <span>Modèle CSV</span>
            </button>
            <label for="file-upload-membres-frontoffice" class="btn normal ml-3 justify-content-center btn-filtre" style="cursor: pointer;">
              <img src="/public/icons/icon-upload.svg" class="btn-icon" alt="" />
              <span>Importer CSV</span>
            </label>
            <button type="button" @click="sendInvitationsUnverified" class="btn normal ml-3 justify-content-center btn-filtre" :disabled="loadingInvitations">
              <img src="/public/icons/icon-send.svg" class="btn-icon" alt="" />
              <span v-if="!loadingInvitations">Envoyer invitations</span>
              <span v-else>Envoi...</span>
            </button>
            <div class="form-field-floating default sm s6_mobile ml-3">
              <select class="form-input-select" name="sort" id="sort" v-model="filters.sort" @change="onFiltersChanged">
                <option value="">Trier</option>
                <option value="fullname_asc">Nom & Prénoms (ASC)</option>
                <option value="fullname_desc">Nom & Prénoms (DESC)</option>
                <option value="created_at_asc">Date (ASC)</option>
                <option value="created_at_desc">Date (DESC)</option>
              </select>
            </div>
            <button 
              class="btn normal white2 s4_mobile ml-4 justify-content-center btn-filtre btn-filter" 
              :class="{ active: showFilters }"
              @click="toggleFilters"
            >
              <img src="/public/icons/icon-filter.svg" class="btn-icon" alt="" />
              <span>Options</span>
            </button>
          </div>
          <div class="clear-both"></div>
          
          <div class="filter-set-area" :class="{ active: showFilters }">
            <div class="grid-filter6 mt-4 mb-0">
              <div class="form-field-floating reactive sm">
                <input type="date" class="form-input" name="date1" id="date1" v-model="filters.dateFrom" @change="onFiltersChanged" placeholder="">
                <label for="date1">Date de création &lt;=</label>
              </div>
              <div class="form-field-floating reactive sm">
                <input type="date" class="form-input" name="date2" id="date2" v-model="filters.dateTo" @change="onFiltersChanged" placeholder="">
                <label for="date2">Date de création &gt;=</label>
              </div>
              <div class="form-field-floating sm">
                <select class="form-input-select" name="etat" id="etat" v-model="filters.etat" @change="onFiltersChanged">
                  <option value="" selected>Tout les etats</option>
                  <option value="actif">Actif</option>
                  <option value="inactif">Inactif</option>
                </select>
                <label for="etat">Etat <b class="color-danger">*</b></label>
              </div>
              <button class="btn black normal justify-content-center mx-0 btn-filtre" @click="handleExportExcel" :disabled="loading">
                <img src="/public/icons/icon-excel.svg" class="btn-icon" alt="" />
                <span>Exporter Excel</span>
              </button>
              <button class="btn black normal justify-content-center mx-0 btn-filtre" @click="handleExportPdf" :disabled="loading">
                <img src="/public/icons/icon-pdf.svg" class="btn-icon" alt="" />
                <span>Exporter PDF</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <table class="table separator skin3 rounded selection">
        <thead>
          <tr>
            <th>
              <label class="btn-circle" for="check-all">
                <input type="checkbox" name="check-all" id="check-all" v-model="selectAll" @change="handleSelectAll" />
              </label>
            </th>
            <th></th>
            <th>
              <img src="/public/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" />
              Transaction
            </th>
            <th>
              <img src="/public/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" />
              Montant
            </th>
            <th>
              <img src="/public/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" />
              Statut
            </th>
            <th>
              <img src="/public/icons/icon-filter-none.svg" class="size-xxs mt--1" alt="" />
              Date
            </th>
            <th class="flex-right">
              <button 
                class="btn-ultra white2 tips" 
                :class="{ 'display-none': selectedItems.length === 0 }"
                :disabled="loading"
                @click="doDeleteSelectedItems"
              >
                <div class="btn-show">
                  <img src="/public/icons/icon-delete.svg" class="btn-icon" alt="" />
                  <span>Supprimer</span>
                </div>
                <div class="btn-loading" :class="{ 'display-none': !loading }">
                  <div class="loader-dots"></div>
                </div>
              </button>
              <button 
                class="btn-ultra color2 tips" 
                :class="{ 'display-none': selectedItems.length === 0 }"
                :disabled="loading"
                @click="doToggleEtatValideSelectedItems"
              >
                <div class="btn-show">
                  <img src="/public/icons/icon-actif.svg" class="btn-icon" alt="" />
                  <span>Actif</span>
                </div>
                <div class="btn-loading" :class="{ 'display-none': !loading }">
                  <div class="loader-dots"></div>
                </div>
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="members.length === 0">
            <tr>
              <td colspan="7">
                <div class="text-center text-grey-700 py-10">Aucun membre trouvé</div>
              </td>
            </tr>
          </template>
          <template v-for="(member, index) in members" :key="member.id || index">
            <tr class="text-grey-700 over-effect" @click="goToMemberDetail(member.id)" style="cursor: pointer;">
              <td class="selection-item" @click.stop>
                <label class="btn-circle" :for="'check-' + index">
                  <input
                    type="checkbox"
                    :id="'check-' + index"
                    :value="member.id"
                    v-model="selectedItems"
                  />
                </label>
              </td>
              <td class="flex">
                <div class="square-xl rounded-15" style="background-color: rgb(var(--color-warning-rgb), 0.2);">
                  <img :src="member.photo_url ? member.photo_url : '/public/assets/users/300w/user2.jpg'" width="100%" />
                </div>
                <div class="square-xl rounded-15 ml-3 px-3 py-3" :style="{ backgroundColor: getCardColor(member.actif === 1 ? 'actif' : 'inactif') }">
                  <img src="/public/icons/icon-carte.svg" width="100%" />
                </div>
              </td>
              <td>
                <h5 class="mb-1 font-semibold">{{ member.nom }}</h5>
                <span class="text-sm text-grey-500">{{ member.prenom }}</span>
              </td>
              <td>
                <p class="mb-2 color-info">{{ member.collectivite?.nom || member.collectivite || 'N/A' }}</p>
              </td>
              <td>
                {{ member.actif === 1 ? 'Actif' : 'Inactif' }}<br />
                <span class="text-sm text-grey-500">{{ formatDate(member.created_at) }}</span>
              </td>
              <td>
                Dernière connexion<br />
                <b class="text-sm text-grey-500">{{ formatDate(member.created_at) }}</b>
              </td>
              <td class="flex-right">
                <button 
                  class="btn-ultra white2 tips" 
                  :class="{ 'display-none': member.deleted_at === null }"
                  :disabled="loading"
                  @click.stop="doDeleteItem(member)"
                >
                  <div class="btn-show">
                    <img src="/public/icons/icon-destroy.svg" class="btn-icon icon-neutral" alt="" />
                    <span>Détruire</span>
                  </div>
                  <div class="btn-loading" :class="{ 'display-none': !loading }">
                    <div class="loader-dots"></div>
                  </div>
                </button>
                <button 
                  class="btn-ultra white2 tips" 
                  :class="{ 'display-none': member.deleted_at !== null }"
                  :disabled="loading"
                  @click.stop="doDeleteItem(member)"
                >
                  <div class="btn-show">
                    <img src="/public/icons/icon-delete.svg" class="btn-icon" alt="" />
                    <span>Supprimer</span>
                  </div>
                  <div class="btn-loading" :class="{ 'display-none': !loading }">
                    <div class="loader-dots"></div>
                  </div>
                </button>
                <button 
                  class="btn-ultra white2 tips" 
                  :class="{ 'display-none': member.deleted_at === null }"
                  :disabled="loading"
                  @click.stop="doRestoreItem(member)"
                >
                  <div class="btn-show">
                    <img src="/public/icons/icon-restaurer.svg" class="btn-icon icon-neutral" alt="" />
                    <span>Restaurer</span>
                  </div>
                  <div class="btn-loading" :class="{ 'display-none': !loading }">
                    <div class="loader-dots"></div>
                  </div>
                </button>
                <button 
                  class="btn-ultra color2 tips" 
                  :class="{ 'display-none': member.deleted_at !== null || member.actif !== 1 }"
                  :disabled="loading"
                  @click.stop="doToggleEtatValideAction([member.id])"
                >
                  <div class="btn-show">
                    <img src="/public/icons/icon-actif.svg" class="btn-icon" alt="" />
                    <span>Actif</span>
                  </div>
                  <div class="btn-loading" :class="{ 'display-none': !loading }">
                    <div class="loader-dots"></div>
                  </div>
                </button>
                <button class="btn" @click.stop="goToMemberEdit(member.id)" :disabled="loading">
                  <img src="/public/icons/icon-edit.svg" class="btn-icon" alt="" />
                  <span>Editer</span>
                </button>
                <button class="btn white2 collapse-open-table" @click.stop="toggleRowDetails(index)">
                  <img src="/public/icons/icon-list.svg" class="btn-icon" alt="" />
                  <span>Plus</span>
                </button>
              </td>
            </tr>
            <tr class="bg-white" v-if="expandedRows.includes(index)">
              <td colspan="7" class="collapse-content-table">
                <div class="grid6 grid-row-gap-1 px-10 pb-4">
                  <p class="flex text-grey-600" v-for="(permission, pIndex) in (member.permissions || [])" :key="pIndex">
                    <img src="/public/icons/icon-securite-permission.svg" class="size-xs icon-grey mr-2" alt="" />
                    {{ permission }}
                  </p>
                  <p v-if="!member.permissions || member.permissions.length === 0" class="flex text-grey-600">
                    Aucune permission spécifiée
                  </p>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <div class="clear-both h-5"></div>

    <!--Pagination-->
    <div class="pagination sm justify-content-right mb-0">
      <button class="page-link" :class="{ active: currentPage === 1 }" @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
        <img src="/public/icons/icon-pagination-prev.svg" class="pagination-icon" alt="" />
        Précedent
      </button>
      <button
        v-for="page in visiblePages"
        :key="page"
        class="page-link"
        :class="{ active: currentPage === page }"
        @click="goToPage(page)"
      >
        {{ page }}
      </button>
      <button class="page-link pl-4" @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">
        Suivant
        <img src="/public/icons/icon-pagination-next.svg" class="pagination-icon ml-2" alt="" />
      </button>
    </div>
    <!---->
    
    <div class="clear-both h-70"></div>
  </section>
</template>

<script setup lang="ts">
import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import membersService from '@/services/membersService'
import authService from '@/services/authService'
import { showAlert, showConfirm, showToast } from '@/utils/swal'
import ImportMembresComponent from '@/components/ImportMembresComponent.vue'

const router = useRouter()

interface Member {
  id: number
  nom: string
  prenom: string
  collectivite?: {
    id: number
    nom: string
  }
  photo?: string
  photo_url?: string
  email?: string
  telephone?: string
  created_at: string
  actif: number
  deleted_at?: string | null
  fonction?: string
  permissions?: string[]
}

const showFilters = ref(false)
const selectedItems = ref<number[]>([])
const selectAll = ref(false)
const expandedRows = ref<number[]>([])
const currentPage = ref(1)
const perPage = ref(10)
const loading = ref(false)
const loadingInvitations = ref(false)
const errorMessage = ref('')
const refreshKey = ref(0)
const startupInfos = reactive({
  collectivites: [] as any[],
  pays: [] as any[]
})

const filters = reactive({
  sort: '',
  dateFrom: '',
  dateTo: '',
  etat: ''
})

// Données réelles depuis l'API
const members = ref<Member[]>([])
const pagination = reactive({
  total: 0,
  per_page: 10,
  last_page: 1
})

onMounted(async () => {
  await loadStartupInfos()
  await loadMembers()
})

async function loadStartupInfos() {
  try {
    const data = await membersService.getStartupInfos()
    startupInfos.collectivites = data.collectivites || []
    startupInfos.pays = data.pays || []
  } catch (error: any) {
    console.error('Erreur lors du chargement des données de démarrage:', error)
  }
}

async function loadMembers() {
  try {
    loading.value = true
    errorMessage.value = ''
    
    // Récupérer la collectivité de l'utilisateur connecté
    let currentUser = authService.getCurrentUser()
    
    // Si les données utilisateur ne contiennent pas la collectivité, récupérer le profil complet
    if (currentUser && !currentUser.collectivite_id && !currentUser.collectivite?.id && !(currentUser as any).collectiviteId) {
      try {
        const profileResponse = await authService.getProfile()
        if (profileResponse.status === 0 && profileResponse.data) {
          currentUser = profileResponse.data
          // Mettre à jour les données utilisateur dans le stockage
          const TokenStorage = (await import('@/services/apiConfig')).TokenStorage
          TokenStorage.setUser(currentUser)
        }
      } catch (profileError) {
        console.error('Erreur lors de la récupération du profil:', profileError)
      }
    }
    
    const userCollectiviteId = currentUser?.collectivite_id || (currentUser as any)?.collectiviteId || currentUser?.collectivite?.id || null
    
    if (!userCollectiviteId) {
      errorMessage.value = 'Aucune collectivité associée à votre compte'
      members.value = []
      return
    }
    
    // Gestion du tri
    let sortColumn = 'fullname'
    let sortDir = 'ASC'
    let sortOption = 'fullname_asc'
    
    if (filters.sort) {
      sortOption = filters.sort
      if (filters.sort === 'fullname_asc') {
        sortColumn = 'fullname'
        sortDir = 'ASC'
      } else if (filters.sort === 'fullname_desc') {
        sortColumn = 'fullname'
        sortDir = 'DESC'
      } else if (filters.sort === 'created_at_asc') {
        sortColumn = 'created_at'
        sortDir = 'ASC'
      } else if (filters.sort === 'created_at_desc') {
        sortColumn = 'created_at'
        sortDir = 'DESC'
      }
    }
    
    const queryParams: any = {
      pageNumber: currentPage.value,
      pageSize: perPage.value, // L'API backoffice utilise pageSize, pas per_page
      sortColumn,
      sortDir,
      sortOption,
      collectivite_id: String(userCollectiviteId) // Filtrer par collectivité
    }
    
    // Filtres de date
    if (filters.dateFrom) {
      queryParams.borneInf = filters.dateFrom
    }
    if (filters.dateTo) {
      queryParams.borneSup = filters.dateTo
    }
    
    // Filtre d'état (trashed: 0 = actifs, 1 = supprimés/inactifs)
    if (filters.etat === 'inactif') {
      queryParams.trashed = 1
    } else if (filters.etat === 'actif') {
      queryParams.trashed = 0
    }
    
    const response = await membersService.listMembers(queryParams)
    
    // LengthAwarePaginator retourne directement les propriétés dans response
    members.value = response.data || []
    pagination.total = response.total || 0
    pagination.per_page = response.per_page || 10
    pagination.last_page = response.last_page || 1
  } catch (error: any) {
    console.error('Erreur lors du chargement des membres:', error)
    errorMessage.value = error.message || 'Erreur lors du chargement des membres'
    members.value = []
  } finally {
    loading.value = false
  }
}

const totalPages = computed(() => pagination.last_page || Math.ceil(members.value.length / perPage.value))

const visiblePages = computed(() => {
  const pages: number[] = []
  const maxVisible = 3
  let start = Math.max(1, currentPage.value - Math.floor(maxVisible / 2))
  let end = Math.min(totalPages.value, start + maxVisible - 1)
  
  if (end - start < maxVisible - 1) {
    start = Math.max(1, end - maxVisible + 1)
  }
  
  for (let i = start; i <= end; i++) {
    pages.push(i)
  }
  
  return pages.length > 0 ? pages : [1]
})

function toggleFilters() {
  showFilters.value = !showFilters.value
}

function onFiltersChanged() {
  currentPage.value = 1
  loadMembers()
}

function handleSelectAll() {
  if (selectAll.value) {
    selectedItems.value = members.value.map(m => m.id)
  } else {
    selectedItems.value = []
  }
}

function toggleRowDetails(index: number) {
  const member = members.value[index]
  if (member) {
    router.push({ name: 'collectivites-membre-detail', params: { id: member.id } })
  }
}

function goToMemberDetail(memberId: number) {
  router.push({ name: 'collectivites-membre-detail', params: { id: memberId } })
}

function goToMemberEdit(memberId: number) {
  router.push({ name: 'collectivites-membre-edit', params: { id: memberId } })
}

function getCardColor(status: string): string {
  const colors: Record<string, string> = {
    actif: 'rgb(var(--color-info-rgb), 0.2)',
    inactif: 'rgb(var(--color-warning-rgb), 0.2)',
    suspendu: 'rgb(var(--color-danger-rgb), 0.2)'
  }
  return colors[status] || 'rgb(var(--color-info-rgb), 0.2)'
}

function formatDate(dateString: string): string {
  if (!dateString) return ''
  // Si la date est déjà formatée, la retourner telle quelle
  if (dateString.includes('Nov') || dateString.includes('Dec') || dateString.includes('Jan')) {
    return dateString
  }
  // Sinon, formater la date
  try {
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return dateString
    return date.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
  } catch {
    return dateString
  }
}

function goToPage(page: number) {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page
    loadMembers()
  }
}

async function handleExportExcel() {
  try {
    loading.value = true
    errorMessage.value = ''
    
    const queryParams: any = {}
    if (filters.dateFrom) queryParams.borneInf = filters.dateFrom
    if (filters.dateTo) queryParams.borneSup = filters.dateTo
    if (filters.etat) queryParams.trashed = filters.etat === 'inactif' ? 1 : 0
    
    const blob = await membersService.exportToExcel(queryParams)
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'membres.xlsx')
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de l\'export Excel'
  } finally {
    loading.value = false
  }
}

async function handleExportPdf() {
  try {
    loading.value = true
    errorMessage.value = ''
    
    const queryParams: any = {}
    if (filters.dateFrom) queryParams.borneInf = filters.dateFrom
    if (filters.dateTo) queryParams.borneSup = filters.dateTo
    if (filters.etat) queryParams.trashed = filters.etat === 'inactif' ? 1 : 0
    
    const blob = await membersService.exportToPdf(queryParams)
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'membres.pdf')
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de l\'export PDF'
  } finally {
    loading.value = false
  }
}

async function doDeleteItem(member: Member) {
  const confirmation = await showConfirm(
    `Voulez-vous vraiment supprimer le membre ${member.nom} ${member.prenom} ?`,
    'Confirmation de suppression'
  )
  if (!confirmation) return

  try {
    loading.value = true
    errorMessage.value = ''
    await membersService.deleteMember(member.id)
    await showAlert.success('Membre supprimé avec succès.', 'Suppression réussie')
    await loadMembers() // Recharger la liste
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de la suppression du membre.'
    await showAlert.error(errorMessage.value, 'Erreur de suppression')
  } finally {
    loading.value = false
  }
}

async function doRestoreItem(member: Member) {
  const confirmation = await showConfirm(
    `Voulez-vous vraiment restaurer le membre ${member.nom} ${member.prenom} ?`,
    'Confirmation de restauration'
  )
  if (!confirmation) return

  try {
    loading.value = true
    errorMessage.value = ''
    await membersService.restoreMember(member.id)
    await showAlert.success('Membre restauré avec succès.', 'Restauration réussie')
    await loadMembers() // Recharger la liste
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de la restauration du membre.'
    await showAlert.error(errorMessage.value, 'Erreur de restauration')
  } finally {
    loading.value = false
  }
}

async function doToggleEtatValideAction(ids: number[]) {
  const confirmation = await showConfirm(
    `Voulez-vous vraiment modifier l'état des membres sélectionnés ?`,
    'Confirmation de modification'
  )
  if (!confirmation) return

  try {
    loading.value = true
    errorMessage.value = ''
    await membersService.toggleEtatValide(ids)
    await showAlert.success('État des membres mis à jour avec succès.', 'Mise à jour réussie')
    selectedItems.value = [] // Réinitialiser la sélection
    await loadMembers() // Recharger la liste
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de la modification de l\'état des membres.'
    await showAlert.error(errorMessage.value, 'Erreur de mise à jour')
  } finally {
    loading.value = false
  }
}

async function doDeleteSelectedItems() {
  if (selectedItems.value.length === 0) {
    await showAlert.warning('Veuillez sélectionner au moins un membre à supprimer.', 'Aucune sélection')
    return
  }

  const confirmation = await showConfirm(
    `Voulez-vous vraiment supprimer les ${selectedItems.value.length} membre(s) sélectionné(s) ?`,
    'Confirmation de suppression multiple'
  )
  if (!confirmation) return

  try {
    loading.value = true
    errorMessage.value = ''
    // Supprimer chaque membre sélectionné
    for (const id of selectedItems.value) {
      await membersService.deleteMember(id)
    }
    await showAlert.success(`${selectedItems.value.length} membre(s) supprimé(s) avec succès.`, 'Suppression multiple réussie')
    selectedItems.value = [] // Réinitialiser la sélection
    await loadMembers() // Recharger la liste
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de la suppression multiple des membres.'
    await showAlert.error(errorMessage.value, 'Erreur de suppression multiple')
  } finally {
    loading.value = false
  }
}

async function doToggleEtatValideSelectedItems() {
  if (selectedItems.value.length === 0) {
    await showAlert.warning('Veuillez sélectionner au moins un membre pour modifier son état.', 'Aucune sélection')
    return
  }
  await doToggleEtatValideAction(selectedItems.value)
}

async function downloadCsv() {
  try {
    const blob = await membersService.downloadCsvTemplate()
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", "collectivite_membres_template.csv")
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
    showToast.success('Modèle CSV téléchargé avec succès')
  } catch (error: any) {
    console.error("Erreur de téléchargement :", error)
    showToast.error('Erreur lors du téléchargement du modèle CSV')
  }
}

function onMembersImported() {
  refreshKey.value++
  loadMembers()
}

async function sendInvitationsUnverified() {
  try {
    // Récupérer le nombre de membres non vérifiés
    const countResponse = await membersService.countUnverifiedMembers()
    const unverifiedCount = countResponse.count || 0
    
    if (unverifiedCount === 0) {
      showToast.info("Aucun membre non vérifié trouvé pour cette collectivité")
      return
    }
    
    // Afficher la confirmation
    const confirmation = await showConfirm(
      `Vous êtes sur le point d'envoyer ${unverifiedCount} invitation(s) aux membres non vérifiés de cette collectivité. Voulez-vous continuer ?`,
      "Envoyer les invitations"
    )
    
    if (!confirmation) {
      return
    }
    
    loadingInvitations.value = true
    
    const response = await membersService.sendInvitationsUnverified()
    
    showToast.success(response.message || 'Invitations envoyées avec succès')
    
    // Rafraîchir la liste après l'envoi
    setTimeout(() => {
      loadMembers()
    }, 1000)
  } catch (error: any) {
    console.error("Erreur lors de l'envoi des invitations:", error)
    showToast.error(error.message || "Une erreur est survenue lors de l'envoi des invitations")
  } finally {
    loadingInvitations.value = false
  }
}
</script>

<style scoped>
</style>
